import { Modal } from "newui/components/ui/Modal";

import type { PastProject } from "newui/features/Company/types";
import { MobilePrimaryProjectCard } from "./mobile/MobilePrimaryProjectCard";

interface ProjectDetailModalProps {
	isOpen: boolean;
	profileTypeId: number;
	project: PastProject | null;
	onClose: () => void;
}

export const ProjectDetailModal: React.FC<ProjectDetailModalProps> = ({
	project,
	profileTypeId,
	isOpen,
	onClose,
}) => {
	if (!project) return null;

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={project.name}
			size="6xl"
			modalType="standard"
			iconType="info"
			closeOnOverlayClick
			closeOnEsc
		>
			<MobilePrimaryProjectCard
				project={project}
				profileTypeId={profileTypeId}
				variant="flat"
			/>
		</Modal>
	);
};
